import React from 'react'

// app root
import AppRoot from 'components/AppRoot'

export default function App() {
	return (
		<React.Fragment>
			<AppRoot />
		</React.Fragment>
	)
}
